<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { decode } from '@/utils/utils'
export default {
  name: 'App',
  created() {
    let { minfo } = this.$route.query
    if (minfo) {
      let userInfo = JSON.parse(decode(minfo))
      let { id, token } = userInfo
      if (id && token) {
        this.get(`osapi/member/getInfoNew?token=${token}`, {
          member_id: id
        }).then(res => {
          let { code, data, msg } = res.data;
          if (code == 1) {
            localStorage.setItem('user', JSON.stringify(data));
            localStorage.setItem('token', JSON.stringify(token));
            // location.href = '/'
          } else {
            this.$message.warning(msg)
          }
        })
      }
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue